import TemplateView from '../../../TemplateView'
import WorkflowStatus from '../../WorkflowStatus'
import ComponentWithCheckbox from '../../../components/ComponentWithCheckbox'

export class WorkflowStatusWithCheckboxNode extends TemplateView {
    constructor(status, onChangeStatus) {
        super(null);

        this.params = {
            status: status,
            onChangeStatus: onChangeStatus
        }

        this.state = {
            checked: false
        }

        this.onStateChanged(() => this._updateView());
    };


    templateHtml() {
        return '<div class="workflowStatusNode"></div>'
    }

    afterRender() {
        let workStatusButton = new WorkflowStatus({...this.params.status});
        this.checkbox = new ComponentWithCheckbox({
            labelComponent: workStatusButton,
            onChange: (config) => this.params.onChangeStatus(this.params.status, config.checked),
            checkboxTitleAdditionalClass: "workflowStatusNode_label",
            checkmarkAdditionalClass: "workflowStatusNode_checkmark",
        }).init(this.$el);
    }

    _updateView() {
        this.checkbox.setState({"checked": this.state.checked});
    }
}

export default WorkflowStatusWithCheckboxNode



// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/statusFilter/WorkflowStatusCheckboxNode.js